var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-home container"},[(_vm.pageData.data)?[_vm._l((_vm.pageData.data.blocks),function(block,i){return [_c('div',{staticClass:"mt-l"},[_c(block.block,{tag:"component",attrs:{"data":block}})],1)]}),_c('div',{staticClass:"mt-xl"})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }